import { ROUTES } from '../../content/routes';
import { el } from '../components/el';

/** Choose today's trotro line, or 🔀 for a different one at random. Draft routes (stops not yet confirmed) are labelled. */
export function createRoutePicker(onPick: (id: string) => void, onShuffle: () => void): { root: HTMLElement; select: (id: string) => void } {
  const root = el('div', 'route-picker');
  const label = el('label', 'route-picker-label', 'Route');
  const select = el('select', 'route-select');
  for (const route of ROUTES) {
    const option = el('option', '', route.draft ? `${route.name} (draft)` : route.name);
    option.value = route.id;
    select.append(option);
  }
  select.addEventListener('change', () => onPick(select.value));
  const shuffle = el('button', 'route-shuffle', '🔀');
  shuffle.type = 'button';
  shuffle.title = 'Another route';
  shuffle.setAttribute('aria-label', 'Pick another route at random');
  shuffle.addEventListener('click', onShuffle);
  root.append(label, select, shuffle);
  return {
    root,
    select: (id: string) => {
      select.value = id;
    },
  };
}
